export enum AppInitializationActionTypes {
  FONT_STYLE_LOADING = 'FONT_STYLE_LOADING',
  FONT_STYLE_FINISHED_LOADING = 'FONT_STYLE_FINISHED_LOADING',
  SET_APP_FADE_CLASS_TO_FADE_IN = 'SET_APP_FADE_CLASS_TO_FADE_IN',
}
